export const platform = {
  title: "Plataforma",
  backTo: "Volver a {{organization}}",
  backToApp: "Volver a Punto.Firma",
  tabs: {
    organizations: "Organizaciones",
    support: "Accesos de soporte",
    catalog: "Catálogo de webs",
  },
  organizations: {
    description:
      "Alta de organizaciones y su primer administrador. Aquí no se ven certificados, titulares ni actividad de las organizaciones.",
    new: "Nueva organización",
    search: "Buscar por nombre o dominio",
    columns: {
      name: "Nombre",
      domains: "Dominios",
      people: "Personas",
      certificates: "Certificados",
      createdAt: "Alta",
      status: "Estado",
    },
    empty: "Todavía no hay organizaciones",
    edit: "Editar",
    statuses: {
      active: "Activa",
      suspended: "Suspendida",
    },
  },
  form: {
    newTitle: "Nueva organización",
    newDescription:
      "Las personas entran con Google si su dominio está aquí y la organización las ha invitado.",
    editTitle: "Editar «{{name}}»",
    name: "Nombre",
    slug: "Identificador",
    slugHint: "Minúsculas, números y guiones. No se puede cambiar después.",
    domains: "Dominios de Google Workspace",
    domainsHint: "Uno por línea o separados por comas.",
    retention: "Retención del registro (días)",
    firstAdmin: "Primer administrador",
    firstAdminHint: "Se le invita como administrador; entra con Google.",
    create: "Dar de alta",
    created: "Organización «{{name}}» dada de alta",
    saved: "Organización guardada",
    status: "Estado",
    suspend: "Suspender la organización",
    suspendTitle: "¿Suspender «{{name}}»?",
    suspendDescription:
      "Nadie de la organización podrá entrar ni firmar hasta que se reactive. No se borra nada.",
    suspendConfirm: "Suspender",
    suspended: "«{{name}}» está suspendida",
    reactivate: "Reactivar la organización",
    reactivated: "«{{name}}» vuelve a estar activa",
    admins: "Administradores",
    adminsEmpty: "Sin administradores todavía.",
    addAdmin: "Invitar administrador",
    adminEmail: "Email del administrador",
    adminAdded: "{{email}} invitado como administrador",
    errors: {
      name: "Ponle un nombre.",
      slug: "Solo minúsculas, números y guiones (sin empezar ni acabar en guion).",
      domains: "Al menos un dominio válido (p. ej. empresa.es).",
      domain: "«{{domain}}» no es un dominio válido.",
      retention: "Entre 30 y 3650 días.",
      email: "Escribe un email válido.",
    },
  },
  catalog: {
    description:
      "Las webs en las que se pueden usar los certificados del cloud. Cada dominio cubre sus subdominios. La CA del proxy de cada Mac solo vale para estos dominios: al publicar una versión con dominios nuevos, cada Mac verá «Actualizar webs permitidas» y pedirá la contraseña una vez.",
    summary: "Versión {{version}} · {{domains}} dominios en {{groups}} grupos",
    requested:
      "Para usar «{{domain}}» en una política, añádelo al grupo que le corresponda (ya está escrito en cada uno: pulsa «Añadir» en el bueno, o crea un grupo nuevo) y publica la versión.",
    groupId: "En las reglas: {{id}}",
    domainLabel: "Dominio",
    domainPlaceholder: "sede.ejemplo.es",
    siteLabel: "Nombre de la sede (opcional)",
    sitePlaceholder: "Ayuntamiento de Ejemplo",
    add: "Añadir",
    remove: "Quitar {{domain}}",
    added: "Nuevo",
    newGroup: "Nuevo grupo",
    newGroupTitle: "Nuevo grupo",
    newGroupDescription:
      "Un grupo junta dominios para usarlos de una vez en las políticas (@identificador).",
    groupIdLabel: "Identificador",
    groupIdHint: "Minúsculas, números, «-» y «_». Se usa como @identificador.",
    groupNameLabel: "Nombre",
    createGroup: "Crear grupo",
    pending:
      "Cambios sin publicar: {{added}} dominios nuevos y {{removed}} quitados.",
    pendingSitesOnly: "Cambios sin publicar en los nombres de las sedes.",
    discard: "Descartar",
    publish: "Publicar versión {{version}}",
    publishTitle: "¿Publicar la versión {{version}} del catálogo?",
    publishDescription:
      "Las políticas de todas las organizaciones podrán usar los dominios nuevos enseguida. Cada Mac verá «Actualizar webs permitidas»; hasta que la pulse, esas webs pasan sin el certificado del cloud.",
    publishNoCa:
      "No cambian los dominios: los Macs no tienen que actualizar nada.",
    notesLabel: "Motivo (queda en el historial)",
    published: "Versión {{version}} publicada",
    stale:
      "Alguien ha publicado otra versión mientras editabas. Vuelve a cargar el catálogo.",
    reload: "Volver a cargar",
    history: "Historial",
    historyDescription:
      "Cada publicación es una versión nueva; las anteriores no cambian.",
    columns: {
      version: "Versión",
      date: "Fecha",
      by: "Quién",
      changes: "Cambios",
      notes: "Motivo",
    },
    migration: "Migración",
    initial: "Catálogo inicial ({{count}} dominios)",
    noChanges: "Solo nombres de sedes",
    errors: {
      domain: "«{{domain}}» no es un dominio válido (p. ej. sede.ejemplo.es).",
      duplicate: "«{{domain}}» ya está en el catálogo.",
      nested: "«{{domain}}» ya lo cubre «{{parent}}».",
      groupId: "Solo minúsculas, números, «-» y «_».",
      groupIdTaken: "Ya hay un grupo @{{id}}.",
      groupName: "Ponle un nombre.",
    },
  },
  support: {
    description:
      "Solo los accesos que conceden las organizaciones desde su página. Entrar con uno queda registrado en las dos partes.",
    columns: {
      organization: "Organización",
      who: "Para",
      access: "Acceso",
      reason: "Motivo",
      until: "Hasta",
      status: "Estado",
    },
    access: {
      read_only: "Solo ver",
      full: "Ver y cambiar",
    },
    team: "Equipo de soporte",
    enter: "Entrar",
    entering: "Entrando…",
    empty: "Ninguna organización ha concedido acceso de soporte.",
    status: {
      active: "Vigente",
      revoked: "Revocado",
      expired: "Caducado",
      scheduled: "Programado",
    },
  },
};
